/**
 * Created by Mikhail Menshenin on 09.08.2024
 */

const CoinSlotMachine = function () {
    cleverapps.EventEmitter.call(this);

    this.counter = new Counter();
    this.state = CoinSlotMachine.IDLE_STATE;
    this.autoSpin = false;
    this.message = "";
    this.spins = 0;
    this.reels = [];
    for (let i = 0; i < CoinSlotMachine.REELS_AMOUNT; i++) {
        this.reels.push(new CoinSlotMachineReel(i));
    }

    this.counter.registerStage(1, this.afterSpin.bind(this));
    this.counter.registerStage(20, this.showMessage.bind(this));
    this.counter.registerStage(30, this.receiveReward.bind(this));
    this.counter.registerStage(40, this.doAction.bind(this));
    this.counter.registerStage(50, this.doAutoSpin.bind(this));
    this.counter.registerStage(60, this.outOfSpins.bind(this));
};

CoinSlotMachine.prototype = Object.create(cleverapps.EventEmitter.prototype);
CoinSlotMachine.prototype.constructor = CoinSlotMachine;

CoinSlotMachine.prototype.init = function () {
    this.energy = this.getEnergy();
    cleverapps.lives.on("changeAmount", this.onChangeEnergy.bind(this));
    cleverapps.shields.on("change", this.checkShieldExceeded.bind(this));
};

CoinSlotMachine.prototype.isForceAvailable = function () {
    return !cleverapps.forces.isShown(Forces.SLOT_MACHINE.id);
};

CoinSlotMachine.prototype.isHelpForceAvailable = function () {
    return !cleverapps.forces.isShown(Forces.SLOT_MACHINE_HELP.id);
};

CoinSlotMachine.prototype.getEnergy = function () {
    return cleverapps.lives.amount;
};

CoinSlotMachine.prototype.getEnergyOver = function () {
    return this.getEnergy() - this.getMaxEnergy();
};

CoinSlotMachine.prototype.setEnergy = function (value, silent) {
    cleverapps.lives.setAmount(value, silent);
};

CoinSlotMachine.prototype.addEnergy = function (value, silent, delta) {
    this.setEnergy(this.getEnergy() + value, silent);
    if (delta) {
        this.trigger("deltaEnergy", value);
    }
};

CoinSlotMachine.prototype.getMaxEnergy = function () {
    return cleverapps.lives.getMaxLives();
};

CoinSlotMachine.prototype.isFullEnergy = function () {
    return this.getEnergy() >= this.getMaxEnergy();
};

CoinSlotMachine.prototype.getEnergyRestoreTimeLeft = function () {
    return cleverapps.lives.calcTimeLeft();
};

CoinSlotMachine.prototype.canSpin = function () {
    return cleverapps.lives.canTake(this.getSpinCost());
};

CoinSlotMachine.prototype.getSpinCost = function () {
    return 1;
};

CoinSlotMachine.prototype.spin = function () {
    if (this.counter.isActive()) {
        return false;
    }

    if (!(this.state === CoinSlotMachine.IDLE_STATE || this.state === CoinSlotMachine.DO_ACTION_STATE)) {
        return false;
    }

    if (!this.canSpin()) {
        this.counter.inc();
        this.trigger("spin", () => {
            this.counter.dec();
        }, true);
        return false;
    }

    cleverapps.lives.setAmount(cleverapps.lives.amount - this.getSpinCost());

    const payline = this.calcPayline();
    this.force = this.calcForce();
    this.incSpins();

    const reelSpinCount = PseudoRandom.GET().random(17, 19);

    this.reels.forEach((reel, index) => {
        this.counter.inc();
        this.counter.setTimeout(() => {
            reel.spin(payline[index], reelSpinCount, () => {
                this.counter.dec();
            });
        }, index * CoinSlotMachine.REEL_SPIN_DELAY);
    });

    this.state = CoinSlotMachine.SPIN_STATE;

    this.trigger("spin");

    return true;
};

CoinSlotMachine.prototype.incSpins = function () {
    this.spins++;
    this.save();
};

CoinSlotMachine.prototype.doAutoSpin = function () {
    if (this.autoSpin) {
        this.spin(cleverapps.forces.isRunningForce());
    }
};

CoinSlotMachine.prototype.outOfSpins = function () {
    if (!cleverapps.lives.amount) {
        cleverapps.focusManager.display({
            focus: "EnergyShopWindow",
            control: [],
            action: function (f) {
                new EnergyShopWindow();
                cleverapps.focusManager.onceNoWindowsListener = f;
            }
        });
    }
};

CoinSlotMachine.prototype.getMessage = function () {
    const payline = this.getCurrentPayline();
    const config = CoinSlotMachine.getMatchPaylineConfig(payline) || {};
    let message = config.message || "";
    let reward = config.reward;
    if (typeof reward === "function") {
        reward = reward();
    }

    if (reward) {
        if (reward.hard) {
            message = `${aisensia.getNumberWithCommas(reward.hard)} ${TextWithIcon.ICONS_BY_NAME.hard}`;
        }

        if (reward.energy) {
            message = `${reward.energy} spins`;
        }
    }

    return message;
};

CoinSlotMachine.prototype.afterSpin = function () {
    if (this.state === CoinSlotMachine.SPIN_STATE) {
        this.state = CoinSlotMachine.SHOW_MESSAGE_STATE;
    }
};

CoinSlotMachine.prototype.showMessage = function () {
    if (this.state === CoinSlotMachine.SHOW_MESSAGE_STATE) {
        this.message = this.getMessage();
        this.counter.inc();
        this.trigger("message", this.message, () => {
            this.showPaylineForce();
            this.counter.dec();
        });
        this.state = CoinSlotMachine.REWARD_RECIEVE_STATE;
    }
};

CoinSlotMachine.prototype.showPaylineForce = function () {
    if (this.force) {
        this.counter.inc();
        this.trigger("force", this.force, () => {
            this.counter.dec();
        });
    }
};

CoinSlotMachine.prototype.receiveReward = function () {
    if (this.state !== CoinSlotMachine.REWARD_RECIEVE_STATE) {
        return;
    }

    const payline = this.getCurrentPayline();
    const config = CoinSlotMachine.getMatchPaylineConfig(payline) || {};
    let reward = config.reward;
    const action = config.action;

    if (typeof reward === "function") {
        reward = reward();
    }

    let rewardList;
    if (reward) {
        rewardList = new RewardsList(reward, { event: cleverapps.EVENTS.EARN.SLOTMACHINE });
        rewardList.receiveRewards();

        if (reward.hard) {
            this.counter.inc();
            this.trigger("coinsRecieve", config.animation, () => {
                rewardList.onAnimationFinished();
                this.counter.dec();
            });
        }
    }

    if (config.icon_animation) {
        const isEnergyReward = reward && reward.energy;
        if (isEnergyReward) {
            rewardList.onAnimationFinished();
        }
        this.counter.inc();
        this.trigger("iconsRecieve", config, () => {
            this.counter.dec();
            if (reward && !isEnergyReward) {
                rewardList.onAnimationFinished();
            }
        });
    }

    if (config.effect) {
        cleverapps.effects.fire(config.effect);
    }

    if (action) {
        cleverapps.focusManager.display({
            focus: "SlotMachineAction",
            control: [],
            action: function (f) {
                this.actionReleaseCallback = f;
            }.bind(this)
        });
    }

    this.state = CoinSlotMachine.DO_ACTION_STATE;
};

CoinSlotMachine.prototype.doAction = function () {
    if (this.state === CoinSlotMachine.DO_ACTION_STATE) {
        this.state = CoinSlotMachine.IDLE_STATE;
        const payline = this.getCurrentPayline();
        const config = CoinSlotMachine.getMatchPaylineConfig(payline) || {};
        const action = config.action;
        if (action) {
            this.counter.inc();
            action(() => {
                this.counter.dec();
            });
        }
        if (this.actionReleaseCallback) {
            this.actionReleaseCallback();
            delete this.actionReleaseCallback;
        }
    }
};

CoinSlotMachine.prototype.calcPayline = function () {
    let payline = [];
    let excludePaylineSymbols = false;
    if (cleverapps.config.debugMode) {
        if (CoinSlotMachine.PREDEFINED_PAYLINE) {
            payline = cleverapps.clone(CoinSlotMachine.PREDEFINED_PAYLINE);
            excludePaylineSymbols = true;
        } else {
            if (this.debugPayline === undefined) {
                this.debugPayline = 0;
            }
            payline = CoinSlotMachine.DEBUG_PAYLINES[this.debugPayline++ % CoinSlotMachine.DEBUG_PAYLINES.length];
            if (typeof payline[0] !== "string") {
                payline = PseudoRandom.GET().choose(payline);
            }
        }
    }
    if (CoinSlotMachine.FIRST_SESSION_PAYLINES[this.spins]) {
        payline = cleverapps.clone(CoinSlotMachine.FIRST_SESSION_PAYLINES[this.spins]);
        excludePaylineSymbols = true;
    }
    for (let i = payline.length; i < CoinSlotMachine.REELS_AMOUNT; i++) {
        const symbols = payline.reduce((symbols, type) => {
            const exclude = CoinSlotMachine.SYMBOLS[type].exclude || [];

            if (excludePaylineSymbols) {
                exclude.push(type);
            }

            return symbols.filter((symbol) => !exclude.includes(symbol.type));
        }, CoinSlotMachineReel.SYMBOLS);
        payline.push(PseudoRandom.GET().choose(symbols).type);
    }

    return payline;
};

CoinSlotMachine.prototype.calcForce = function () {
    const force = CoinSlotMachine.FORCES.find((force) => force.spin === this.spins);
    return force && force.message;
};

CoinSlotMachine.prototype.onChangeEnergy = function () {
    const energy = this.getEnergy();
    const delta = energy - this.energy;

    if (delta) {
        this.energy = energy;
        this.trigger("changeEnergy", delta < 0);
    }
};

CoinSlotMachine.prototype.getCurrentPayline = function () {
    return this.reels.map((reel) => reel.getCurrent().type);
};

CoinSlotMachine.prototype.checkShieldExceeded = function () {
    if (cleverapps.shields.exceeded) {
        this.addEnergy(1, false, true);
    }
};

CoinSlotMachine.prototype.getInfo = function () {
    return {
        spins: this.spins
    };
};

CoinSlotMachine.prototype.load = function () {
    const data = cleverapps.syncedStorage.load("slotmachine") || {};
    this.spins = data.spins || 0;
};

CoinSlotMachine.prototype.save = function () {
    cleverapps.syncedStorage.save("slotmachine", this.getInfo());
};

CoinSlotMachine.prototype.isBeforeFirstSpin = function () {
    return this.spins === 0;
};

CoinSlotMachine.getMatchPaylineConfig = function (payline) {
    return CoinSlotMachine.PAYLINES.find((config) => !payline.reduce((payline, type) => {
        const index = payline.indexOf(type);

        if (index !== -1) {
            payline.splice(index, 1);
        }

        return payline;
    }, cleverapps.clone(config.payline)).length);
};

CoinSlotMachine.IDLE_STATE = 0;
CoinSlotMachine.SPIN_STATE = 1;
CoinSlotMachine.SHOW_MESSAGE_STATE = 2;
CoinSlotMachine.REWARD_RECIEVE_STATE = 3;
CoinSlotMachine.DO_ACTION_STATE = 4;

cleverapps.InitByFeature["coinslotmachine"] = function () {
    aisensia.slotMachine = new CoinSlotMachine();
    aisensia.slotMachine.load();

    cleverapps.eventBus.on("userChanged", () => {
        aisensia.slotMachine.load();
    });
};

cleverapps.whenAllInitialized(() => {
    aisensia.slotMachine.init();
});
